module.exports = __webpack_public_path__ + "static/media/gallery01.5a3891e8.png";